import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faPlus } from '@fortawesome/free-solid-svg-icons';
//import useToken from '../../../hooks/useToken';

const ModalSeleccionarOpcionModulos = ({
    idLicencia,
    showModalOpcionModulos,
    setShowModalOpcionModulos,
    setShowModalModuloPRO,
    setCargando,
    handleNuevaOrden
}) => {


    //const { token, setToken } = useToken();

    /**
     * Maneja la selección de órdenes existentes
     */
    const handleOrdenesExistentes = () => {
        setShowModalOpcionModulos(false);
        setShowModalModuloPRO(true);
        if (setCargando) setCargando(false);
    };

    /**
     * Maneja la creación de nueva orden
     */
    const handleNuevaOrdenClick = () => {
        if (handleNuevaOrden) {
            handleNuevaOrden();
        } else {
            setShowModalOpcionModulos(false);
            if (setCargando) setCargando(false);
        }
    };

    return (
        showModalOpcionModulos &&
        <Modal
            show={showModalOpcionModulos}
            onHide={() => setShowModalOpcionModulos(false)}
            size="md"
            backdrop="static"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title>
                    Asignación de Módulos - Licencia #{idLicencia}
                </Modal.Title>
                <FalconCloseButton
                    className="btn btn-circle btn-sm transition-base p-0"
                    onClick={() => {
                        setShowModalOpcionModulos(false);
                        if (setCargando) setCargando(false);
                    }}
                />
            </Modal.Header>

            <Modal.Body>
                <Row>
                    <Col md={12}>
                        <div className="text-center mb-4">
                            <h5 className="mb-3">Ya existen órdenes de módulos disponibles para esta licencia</h5>
                            <p className="text-muted">
                                Selecciona una opción para continuar con la asignación de módulos:
                            </p>
                        </div>

                        <Row className="g-3">
                            <Col md={6}>
                                <div
                                    className="card h-100 border-primary cursor-pointer hover-shadow-lg transition-base"
                                    onClick={handleOrdenesExistentes}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="card-body text-center p-4">
                                        <div className="mb-3">
                                            <FontAwesomeIcon
                                                icon={faBoxOpen}
                                                size="3x"
                                                className="text-primary"
                                            />
                                        </div>
                                        <h6 className="card-title text-primary fw-bold mb-2">
                                            Usar Órdenes Existentes
                                        </h6>
                                        <p className="card-text small text-muted mb-0">
                                            Seleccionar de las órdenes de módulos ya compradas por el cliente
                                        </p>
                                    </div>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div
                                    className="card h-100 border-success cursor-pointer hover-shadow-lg transition-base"
                                    onClick={handleNuevaOrdenClick}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <div className="card-body text-center p-4">
                                        <div className="mb-3">
                                            <FontAwesomeIcon
                                                icon={faPlus}
                                                size="3x"
                                                className="text-success"
                                            />
                                        </div>
                                        <h6 className="card-title text-success fw-bold mb-2">
                                            Crear Nueva Orden
                                        </h6>
                                        <p className="card-text small text-muted mb-0">
                                            Crear una nueva orden desde cero para asignar módulos
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer className="justify-content-between">
                <Button
                    onClick={() => {
                        setShowModalOpcionModulos(false);
                        if (setCargando) setCargando(false);
                    }}
                    variant='secondary'
                    size="sm"
                >
                    Cancelar
                </Button>


            </Modal.Footer>
        </Modal>
    );
};

ModalSeleccionarOpcionModulos.propTypes = {
    idLicencia: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    showModalOpcionModulos: PropTypes.bool.isRequired,
    setShowModalOpcionModulos: PropTypes.func.isRequired,
    setShowModalModuloPRO: PropTypes.func.isRequired,
    setCargando: PropTypes.func,
    handleNuevaOrden: PropTypes.func
};

export default ModalSeleccionarOpcionModulos;